import { ApiClient } from '.';
import {
  ContainersResponse,
  RequestContainersParams,
  UpdatedContainerResponse,
  UpdateMaterialTypes,
} from './api-types/containers';
import { dotNameKeyToString } from '../utils/string';
import { ExportParams, AsyncExportResponse } from 'src/types';

export class ContainersApi extends ApiClient {
  getContainersData({ page, pageSize, filters }: RequestContainersParams) {
    return this.requestGet<ContainersResponse>('containers', {
      'page.num': page,
      'page.size': pageSize,
      ...dotNameKeyToString(filters),
    });
  }

  updateContainer({ id, wasteMaterialTypes, hdwpf }: UpdateMaterialTypes) {
    return this.requestPut<
      UpdatedContainerResponse,
      Pick<UpdateMaterialTypes, 'wasteMaterialTypes' | 'hdwpf'>
    >(`containers/${id}`, {
      wasteMaterialTypes,
      hdwpf,
    });
  }

  getAsyncReportByType(params: ExportParams, exportType: string) {
    return this.requestPost<AsyncExportResponse, ExportParams>(
      `containers/export/${exportType}?flowType=2`,
      params,
    );
  }
}
